module.exports = __webpack_public_path__ + "img/slider-img-1.013feadb.png";